import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { Info } from "lucide-react";

interface Task {
  id: string;
  task_label: string;
  pillar: string;
  frequency: string;
  benchmark_percent: number;
  tooltip?: string;
}

interface TaskTableProps {
  tasks: Task[];
  title?: string;
}

export function TaskTable({ tasks, title }: TaskTableProps) {
  if (!tasks || tasks.length === 0) {
    return (
      <div className="text-center py-8 text-muted-foreground">
        No tasks available
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {title && (
        <h3 className="text-lg font-semibold text-foreground">{title}</h3>
      )}
      
      <div className="space-y-2">
        {tasks.map((task) => (
          <div
            key={task.id}
            className="flex justify-between items-start py-2 border-b border-border gap-4"
          >
            <div className="flex items-start gap-2 max-w-[70%]">
              <div className="flex items-center gap-1 text-sm font-medium">
                <span>{task.task_label}</span>
                {task.tooltip && (
                  <TooltipProvider delayDuration={0}>
                    <Tooltip>
                      <TooltipTrigger asChild>
                        <Info className="w-4 h-4 text-muted-foreground cursor-help shrink-0 mt-[2px]" />
                      </TooltipTrigger>
                      <TooltipContent
                        side="right"
                        className="max-w-[280px] leading-snug text-xs"
                      >
                        {task.tooltip}
                      </TooltipContent>
                    </Tooltip>
                  </TooltipProvider>
                )}
              </div>
            </div>

            <div className="text-sm font-medium text-right min-w-[50px]">
              {task.benchmark_percent}%
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}